module.exports = __webpack_public_path__ + "static/P2101453-eb8b6ebca656c8bfcacce56933616449.jpg";